import { Link } from "react-router-dom";
import { COMPANY, SUPPORT_EMAIL } from "@/lib/company";
import { useI18n } from "@/i18n";

// Inline markup for translated strings. Supported tokens:
//   **bold**            -> <strong>
//   `code`              -> <code>
//   {email}             -> support mailto link
//   {l:terms}           -> internal link, label from legalLinks dictionary
//   {l:dpa|Custom text} -> internal link with an explicit (translated) label
//   {operator} {brand} {enterpriseNumber} {vat} {addressLine} -> company details
const TOKEN = /(\*\*[^*]+\*\*|`[^`]+`|\{email\}|\{l:(?:terms|privacy|cookies|legal|dpa)(?:\|[^}]*)?\}|\{operator\}|\{brand\}|\{enterpriseNumber\}|\{vat\}|\{addressLine\})/g;

const LEGAL_PATH = { terms: "/terms", privacy: "/privacy", cookies: "/cookies", legal: "/legal", dpa: "/data-processing" };

const COMPANY_TOKENS = {
  "{operator}": COMPANY.operator,
  "{brand}": COMPANY.brand,
  "{enterpriseNumber}": COMPANY.enterpriseNumber,
  "{vat}": COMPANY.vat,
  "{addressLine}": COMPANY.addressLine,
};

export function RichText({ text, className }) {
  const { t } = useI18n();
  if (text === null || text === undefined) return null;
  const parts = String(text).split(TOKEN);
  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (!part) return null;
        if (part.startsWith("**") && part.endsWith("**")) return <strong key={i}>{part.slice(2, -2)}</strong>;
        if (part.startsWith("`") && part.endsWith("`")) return <code key={i}>{part.slice(1, -1)}</code>;
        if (part === "{email}") {
          return <a key={i} className="text-re-red hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>;
        }
        if (part.startsWith("{l:")) {
          const inner = part.slice(3, -1);
          const [id, label] = inner.split("|");
          return (
            <Link key={i} className="text-re-red hover:underline" to={LEGAL_PATH[id] || "/legal"} data-testid={`legal-link-${id}`}>
              {label || t(`legalLinks.${id}`)}
            </Link>
          );
        }
        if (COMPANY_TOKENS[part] !== undefined) return <span key={i}>{COMPANY_TOKENS[part]}</span>;
        return <span key={i}>{part}</span>;
      })}
    </span>
  );
}
